// https://scotch.io/tutorials/simple-language-translation-in-angular-2-part-2

// lang-en.ts

// 'hello world': 'hello world',
// 'hello greet': 'Hello, %0 %1!',
// 'well done': 'Well done %0',
// 'good bye': 'bye bye',

export const LANG_EN_NAME = "en";

export const LANG_EN_TRANS = {
  LblWeekdays: {
    shorthand: ["Su", "Mo", "Tu", "We", "Th", "Fr", "Sa"],
    longhand: [
      "Sunday",
      "Monday",
      "Tuesday",
      "Wednesday",
      "Thursday",
      "Friday",
      "Saturday"
    ]
  },
  LblMonths: {
    shorthand: [
      "Jan",
      "Feb",
      "Mar",
      "Apr",
      "May",
      "Jun",
      "Jul",
      "Aug",
      "Sep",
      "Oct",
      "Nov",
      "Dec"
    ],
    longhand: [
      "January",
      "February",
      "March",
      "April",
      "May",
      "June",
      "July",
      "August",
      "September",
      "October",
      "November",
      "December"
    ]
  },
  LblButtonText: {
    today: "Today",
    month: "Month",
    week: "Week",
    day: "Day",
    list: "List"
  },

  // Common Name
  LblActivityLog: "Activity Log",
  LblEdit: "Edit",
  LblDelete: "Delete",
  LblRemove: "Remove",
  LblActiveInactive: "Active/Inactive",
  LblActive: "Active",
  LblInactive: "Deactivate",
  LblInactiveReason: "Inactive Reason",
  LblAddNew: "Add New",
  LblAdd: "Add",
  LblUpdate: "Update",
  LblSave: "Save",
  LblCancel: "Cancel",
  LblReset: "Reset",
  LblSelect: "Select",
  LblSuccess: "Success",
  LblWarning: "Warning",
  LblList: "List",
  LblAssign: "Assign",
  LblHome: "Home",
  LblYes: "Yes",
  LblOK: "Ok",
  LblNo: "No",
  LblBack: "Back",
  LblReason: "Reason",
  LblRecordSavedSuccess: "Record Saved Successfully",
  LblRecordDeleteSuccess: "Record Deleted Successfully",
  LblResetPasswordSuccess: "Password Reset successfully",
  LblConfirm: "Confirm",
  LblBlockUnblockConfirm: "Are you sure you want to %0 the %1 ?",
  LblRecordDeleteConfirmation: "Are you sure you want to remove %0 ?",
  LblRecordMultiplDeleteConfirmation:
    "Are you sure you want to remove selected %0?",
  LblConfirmMessage: "Are you sure?",
  LblResetPassword: "Reset Password",
  LblResetPasswordConfirmation: "Are you sure you want to reset password?",
  LblGeoLocationError: "Please Enter Correct Geo Location",
  LblPersonDeleteCheck: "Delete permanently",
  LblBookingCancelSuccess: "Bookings Canceled successfully",
  LblBookingAbortSuccess: "Booking Aborted successfully",
  LblBookingRevokeSuccess: "Booking Revoked successfully",
  LblContactPersonRemoveSuccess: "Contact Person removed successfully",
  LblContactPersonAddedSuccess: "Contact Person added successfully",
  LblNoRecords: "No Record Available",
  LblAffectedBookingList: "Affected booking list",
  LblSubscriptionEndDateError: "Please Enter Subscription End Date",
  LblIsSpecialPeriodAllow:
    "Would you like to apply special period Cost? If Applicable",
  LblContractSlotisnotdefined:
    "Contract Type for below given time slot is not defined",
  LblUnscubscribeSuccess: "Unsubscribe Successfully",
  LblModifiedBy: "Modified By",
  LblModifiedDate: "Modified Date",
  LblContractTypeGroupAvailableForSubscription:
    "No Contract Type Group available to add new %0.",

  LblRemoveContactPersonConfirm:
    "Are you sure you want to remove Contact Person?",
  LblBookingApproveRejectSuccess: "%0 %1 successfully",
  LblRecordAddedSuccess: "%0 added successfully.",
  LblRecordUpdatedSuccess: "%0 updated successfully.",
  LblRecordRemovedSuccess: "%0 removed successfully",
  LblRecordActiveInActiveSuccess: "%0 %1 successfully.",
  LblinvoiceResendSuccess: "%0 resend successfully",
  LblRecordBlokUnBlockSuccess: "%0 %1 successfully.",
  LblEditPage: "Edit %0",
  LblAddPage: "Add %0",
  LblListPage: "%0 List",
  LblKilometers: "Kilometer",
  LblKM: "Km",
  LblDeletePersonNote: "Pending invoices for this person will not be sent",
  LblFileNotFound:"The File does not exist, contact the helpdesk",


  //'LblRecordUnBlockedSuccess':'%0 unBlocked successfully',

  //Instance Clone

  'LblInstanceClone': 'Instance Clone',
  'LblNewInstanceName': 'New Instance Name',
  'LblCloneResult': 'Clone Result',
  'LblCloneStatus': 'Clone Status',
  'CloneError': 'Error occurred While Cloning the Instance And It\'s Corresponding Entities.',


  //Instance Page
  LblCarwiseEnable: "Carwise Enabled",
  LblAdminDependencyValidationOnDelete:
    "Selected Admin cannot be deleted because it is associated with other entity.",
  LblAdminDependencyValidation:
    "Admin Role cannot be removed because it is associated with other entity.",
  LblAdminDependencyAlert: "Admin Dependency Alert",
  LblCarwiseConfiguration: "Carwise Configuration",
  LblCarwiseConnectionUrl: "Connection Url",
  LblCarwiseConnectionUsername: "Connection Username",
  LblCarwiseConnectionPassword: "Connection Password",
  LblCarwiseAutoDeleteFrequencyInDays: "AutoDelete Frequency(InDays)",
  LblDamageImageExtentions: "Damage Image Extensions",

  LblInstance: "Instance",
  LblWegoAdminDependencyValidation:
    "WeGo Admin cannot be deleted because it is associated with other entity",
  LblInstanceName: "Instance Name",
  LblInstanceType: "Instance Type",
  LblDescription: "Description",
  LblCurrencySymbol: "Currency Symbol",
  LblPreferredLanguage: "Language",
  LblTimeZone: "Time Zone",
  LblCurrencyAbbreviation: "Currency Abbreviation",
  LblInstanceDeleteValidation:
    "Cannot Delete Instance Due To Association With Other Entity",
  LblIsBookingApprovalReq: "Booking Approval Required",
  LblInstanceConfiguration: "Instance Configuration",
  LblBookingAlertTime: "Booking Alert Time",
  LblBookingCancelTime: "Booking Cancel Time",
  LblBookingTemporaryTime: "Provisional Booking Time",
  LblVtsRequestTimeout: "VTS Request Timeout",
  LblVtsTripLogTimeout: "VTS Triplog Timeout",
  LblEmailConfiguration: "Email Configuration (SMTP)",
  LblInSeconds: "In Seconds",
  LblFromEmail: "From Email",
  LblHost: "Host",
  LblPort: "Port",
  LblEnableSsl: "Enable SSL",
  LblSmtpEmail: "SMTP Email",
  LblBookingCancelTimeMessage:
    "This defines time (in seconds) after which booking cancellation will not be possible",
  LblBookingTemporaryTimeMessage:
    "Time for provisional Booking. When user has selected the vehicle to book but has not yet been confirmed.",
  LblVtSRequestTimeoutMessage:
    "Time out period for Lock/Unlock command within mobile App.",
  LblVtsTriplogTimeoutMessage:
    "Time out period for calculating the trip after executing lock command.",
  LblContractTypeDeleteValidation:
    "Cannot Delete Contract Type Group Due To Association With Other Entity",
  LblSelectFuelType: "Select Fuel Type",
  LblSelectPricingCatagory: "Select Pricing Catagory",
  LblSelectBodyStyle: "Select Body Style",
  LblSelectVehicleClass: "Select Vehicle Class",
  LblIsImportPersonAllow: "Allow importing person",
  LblValidateLicenseA2SP: "A2SP License Check",
  LblValidateLicense24IDCheck: "24ID License Check",
  LblValidateLicenseForAllBookings: "Revalidate license every booking",

  LblGeofenceLocation: "Geofence Location",
  LblRadius: "Radius",
  LblEmailRecepients: "Email Recipients",
  LblRecepients: "Recipients",
  LblEmailAddresses: "Email addresses",
  LblMap: "Map",

  // AFAS/Azure Config
  LblImportConfiguration: "Import Configuration",
  LblImportConnectionType: "Connection Type",
  LblAfas: "AFAS",
  LblAzure: "Azure",
  LblAzureTenantId: "Azure Tenant ID",
  LblAzureClientId: "Azure Client ID",
  LblAzureClientSecret: "Azure Client Secret",
  LblAfasClientId: "AFAS Client ID",
  LblAfasConnectorName: "AFAS Connector Name",
  LblAfasConnectionType: "AFAS Connection Type",
  LblAfasTest: "Test",
  LblAfasAccept: "Acceptation",
  LblAfasProduction: "Production",
  LblAfasToken: "AFAS Token",
  LblAfasClientIdError: "Please enter AFAS Client ID",
  LblAfasConnectorNameError: "Please enter AFAS Client ID",
  LblAfasConnectionTypeError: "Please enter AFAS Connection Type",
  LblAfasTokenError: "Please enter AFAS-Token",
  LblAzureTenantIdError: "Please enter Azure Tenant ID",
  LblAzureClientIdError: "Please enter Azure Client ID",
  LblAzureClientSecretError: "Please enter Azure Client Secret",

  // SSO Config
  LblSsoConfiguration: "SSO Configuration",
  LblDefaultSsoSharedVehicleGroup: "Default Shared Vehicle Group",
  LblDefaultSsoOrganization: "Default Organization",
  LblDefaultSsoSubscription: "Default Subscription",

  // Dropoff Message
  LblDropoffMessageConfiguration: "Dropoff Message Configuration",
  LblDropoffMessageExternalUrl: "External Url",
  LblDropoffMessageApiKey: "Api Key",
  LblDropoffMessageActive: "Active",

  LblValidate: "Validate",
  LblRejection: "Rejection",
  LblrejectionReasonMsg:
    "Please Provide Reason For rejection of selected booking requests",
  LblApproveConfirmationMsg:
    "Are You Sure you want to approve all selected booking request ?",

  LblBookingCalanderSettings: "Booking calendar settings",
  LblShowDriverInfo: "Show driver information in booking calendar",
  LblOrganizationAdmin: "Organization Admin",
  LblDriverInfoToShow: "Driver information to show",

  //Person Page
  LblUserName: "Username",
  LblFirstName: "First Name",
  LblLastName: "Last Name",
  LblEmail: "Email",
  LblMobileNumber: "Mobile Number",
  LblPhoneNumber: "Phone Number",
  LblHomeAddress: "Home Address",
  LblWorkAddress: "Work Address",
  LblHouseNo: "House No",
  LblHouseExtention: "House Extension",
  LblStreetName: "Street Name",
  LblCity: "City",
  LblZipCode: "Zip Code",
  LblPassword: "Password",
  LblConfirmPassword: "Confirm Password",
  LblMiddleName: "Middle Name",
  LblMandateId: "Mandate Id",
  LblMandateSignatureDate: "Mandate Signature Date",
  LblIsAmmandment: "Is Ammandment",
  LblRemovePersonDetails: "Remove Person Details",
  LblMonitoring: "Monitoring",
  LblDropoffMessage: "Dropoff message",
  LblPreferredlanguage: "Preferred language",
  LblDebtornr: "Debtornumber",

  LblEnableLogin: "Enable Login",
  LblEnableErrorEscalation: "Enable Error Escalation",
  LblErrorEscalationMinutes: "Error Escalation Minutes",

  //Booking Type
  LblNORMALBOOKINGTYPE: 'NORMAL',
  LblMAINTENANCEBOOKINGTYPE: 'MAINTENANCE',
  LblUNAVAILABLEBOOKINGTYPE: 'UNAVAILABLE',

  //Booking Status
  LblABORTED: 'ABORTED',
  LblCANCELLED: 'CANCELLED',
  LblCONFIRMED: 'CONFIRMED',
  LblFINISHED: 'FINISHED',
  LblNOSHOW: 'NOSHOW',
  LblPENDING: 'PENDING',
  LblREVOKED: 'REVOKED',
  LblRUNNING: 'RUNNING',
  LblREADYFORPAYMENT: 'READYFORPAYMENT',

  //Invoice Status
  LblOPEN: 'OPEN',
  LblSENT: 'SENT',
  LblCLOSED: 'CLOSED',
  LblREQUESTFORPAYMENT: 'REQUESTFORPAYMENT',
  LblREOPEN: 'REOPENED',

  //Booking Request Status
  LblAPPROVEDBOOKINGREQUEST: 'APPROVED',
  LblREJECTEDBOOKINGREQUEST: 'REJECTED',
  LblPENDINGBOOKINGREQUEST: 'PENDING',


  // Error Log
  LblErrorLog: "Error Log",
  LblComponentName: "Component Name",
  LblLogType: "Log Type",
  LblEventDateTime: "Event DateTime",

  // Interface Status
  LblInterfaceStatus: "Interface Status",
  LblLastStatusChangeDateTime: "Last Status Change DateTime",
  LblLastCarwisePollDateTime: "Last Carwise Poll DateTime",
  LblUpdatedDateTime: "Updated DateTime",

  //ErrorEscalation
  LblDuplicateErrorEscalation:
    "Duplicate Error Escalation Configuration Found",
  LblErrorEscalation: "Error Escalation",
  LblComponent: "Component",
  LblSelectAdminLevel: "Select Admin Level",
  LblWegoAdminLevel: "Wego Admin Level",
  LblCustomerAdminLevel: "Customer Admin Level",
  LblInstanceAdminLevel: "Instance Admin Level",
  //Company Page
  LblCompany: "Company",
  LblCompanyName: "Company Name",
  LblContactPerson: "Contact Person",
  LblCompanyAdmin: "Company Admin",
  LblCompanyAddress: "Company Address",
  LblInternalOrganization: "Internal Organization",
  LblNoOfVegicles: "No.Of Vehicles",
  LblNoOfSharedVehicleGroups: "No.Of SVG",
  LblGeoLocation: "Geo Location",
  LblSelectGeoLocation: "Select Location",
  LblPerson: "Person",
  LblRole: "Roles",
  LblDateOfBirth: "Date Of Birth",
  LblDriverLicenceNumber: "Driver Licence Number",
  LblApkExiprationSetting: "Periodic Maintenance Notification Settings",
  LblApkTimeInterval: "Notification Time Interval",
  LblEmailNotification: "Email Notification",
  LblNotificationFrequency: "Notification Frequency",
  lblThresholdFrequency: "Threshold Frequency",
  lblThresholdTimeInterval: "Threshold Time Interval",
  LblIsEmailEnabled: "Notification Email",
  lblThreshold: "Threshold Period",
  LblFrequency: "Frequency",
  LblDay: "Day",
  LblWeek: "WEEK",
  LblMonth: "Month",
  lblPerBooking: "Perbooking",
  LblPersons: "Persons",
  LblPersonOverview: "Person Overview",
  LblCompanies: "Companies",
  //Vehicle Page
  LblVehicle: "Vehicle",
  LblVtsVehicle: "VTS Vehicle",
  LblFleetId: "Fleet ID",
  LblContractId: "Contract ID",
  LblVIN: "VIN",
  LblLicenceTag: "Licence Tag",
  LblLicence: "Licence",
  LblMobile: "Mobile",
  LblVehicleOwner: "Vehicle Owner",
  LblLocationDataExchange: "Location Data Exchange",
  LblBrand: "Brand",
  LblType: "Type",
  LblColor: "Color",
  LblVehicleClass: "Vehicle Class",
  LblPricingCategory: "Pricing Category",
  LblBodyStyle: "Body Style",
  LblAvailable: "Available",
  LblUnAvailable: "Unavailable",
  LblAvailableFrom: "Available From",
  LblAvailableTo: "Available to",
  LblFuelType: "Fuel Type",
  LblMinBookingTimeBefore: "Minimum time available before booking (minutes)",
  LblMinBookingTimeAfter: "Minimum time available after booking (minutes)",
  LblTowbar: "Towbar",
  LblAirco: "Airco",
  LblVehicleAttributes: "Vehicle Attributes",
  LblBlockUnBlock: "Block/Unblock",
  LblRemoveLicense: "Remove License",
  LblRemoveLicenseBirthDate: "Remove License and Birth Date",
  LblLicenseBirthDate: "Birth Date",
  LblBlock: "Block",
  LblUnblock: "Unblock",
  LblAvailableUnAvailable: "Available/Unavailable",
  LblVehicles: "Vehicles",
  LblBookingsOverview: "Bookings Overview",
  LblApkExpirationDateCet: "Periodic Maintenance Expiration Date",
  LblEnabled: "Enabled",
  LblDisabled: "Disabled",
  LblIntialOdometerValue: "Initial Odometer Value",
  LblFuelCardPinCode: "Fuel Card Pin Code",


  LblFuel: "Fuel",
  LblVINnumber: "VIN number",
  LblVehicletype: "Vehicle type",
  LblDoors: "Number of doors",
  LblWeight: "Vehicle weight",
  LblTrunkSpace: "Trunk space",
  LblGears: "Number of gears",
  LblEngineHorsepower: "Engine horsepower (hp)",
  LblFuelConsumption: "Fuel consumption",
  LblSeats: "Number of seats",
  LblDimensions: "Vehicle dimensions",
  LblTransmissionType: "Transmission type",
  LblTransmissionUnknown: "Unknown",
  LblManualTransmission: "Manual",
  LblAutomaticTransmission: "Automatic",

  LblVehicleDetails: "Vehicle details",
  LblSelectVehicletype: "Select vehicle type",
  LblWrongVinNumber: "Wrong VIN number",


  //WEGO2DEV-325(Settings for Dashboard statuses)
  LblVehicleOnSameLocationTime: "Vehicle at same location for more than",
  LblNoBookingIn: "Vehicle not booked in more than",
  lblHour: "Hour",
  //'lblInterval':'HOUR/DAY/WEEK/MONTH',
  lblHourDayWeekMonth: "Hour / Day / Week / Month",

  //SharedVehicleGroup
  LblSharedVehicleGroup: "Shared Vehicle Group",
  LblVehicleGroup: "Vehicle Group",
  LblSharedVehicleGroupAdmin: "Shared Vehicle Group Admin",
  LblDisplayPeriod: "Display Period",
  LblBookingWeekDays: "Booking WeekDays",
  LblBookingInterval: "Booking Interval (minutes)",
  LblBookingStartTime: "Booking Start Time (hh:mm)",
  LblBookingEndTime: "Booking End Time (hh:mm)",
  LblBookingMinDuration: "Minimum Booking Duration (minutes)",
  LblBookingMaxDuration: "Maximum Booking Duration (minutes)",
  LblMaxRecurringBooking: "Maximum Recurring Booking",
  LblPreBookingInterval: "Pre-Booking Interval (minutes)",
  LblPostBookingInterval: "Post-Booking Interval (minutes)",
  LblBookingExtensionTime: "Max. Booking Extension Time (minutes)",
  LblBookAheadTime: 'Booking possible "X" minutes after now',
  LblBookingHorizon: "Booking Horizon",
  LblNumberOfContactTypeGroup: "No.Of Contract Type Groups",
  LblNumberOfContactType: "No.Of Contract Type",
  LblInvoiceInterval: "Invoice Interval",
  LblIsBookingIntervalAlignToCalendar: "Align Booking Interval To Calender",
  LblBookings: "Bookings",
  LblSharedVehicleGroups: "Shared Vehicle Groups",
  LblSharedVehicleGroupOverview: "Shared Vehicle Group Overview",
  LblEarlyOpenInterval: "Early Open Interval (minuten)",
  LblFeatureFlags: "Feature Flags",
  LblCreateBooking: "Create Booking",
  LblEditBooking: "Edit Booking",
  LblLicenseCheck: "License Check",
  LblBookingLicenseCheck: "Booking License Check",

  //Driver
  LblDriver: "Driver",
  LblLicenceNumber: "Licence No",
  LblDriverName: "Driver Name",
  LblDriverSVG: "Driver Shared Vehicle Group",
  LblDriverUserName: "Driver Username",

  //VehicleAttribute
  LblVehicleAttributeCategory: "Vehicle Attribute Category",
  LblVehicleAttributeName: "Attribute Name",
  LblVehicleAttributeDesc: "Description",
  LblVehicleAttribute: "Vehicle Attribute",
  LbAdditionallVehicleAttribute: "Additional Vehicle Attributes",
  LblVehicleAttributeCategories: "Vehicle Attribute Categories",

  //ContractType Page
  LblRegular: "Regular",
  LblWeekEnd: "Weekend",
  LblDayCT: "Day",
  LblExtraTimeBefore: "Extra Time Before (Minute)",
  LblExtraTimeAfter: "Extra Time After (Minute)",
  LblFreeTextDescription: "Specify the special booking rate plus begin and end times (free text)",
  LblPeriodRate: "Period Rate",
  LblPeriodRateVat: "Period Rate VAT",
  LblSelectContractTypeType: "Select Contract Type Type",
  LblContractTypeType: "Contract Type Type",
  LblContractType: "Contract Type",
  LblContractName: "Contract Name",
  LblContractTypeGroup: "Contract Type Group",
  LblContractTypeGroupName: "Contract Type Group Name",
  LblContractAvailableDays: "Contract Available Days",
  LblApplicableDays: "Applicable Days",
  LblDayStartTime: "Day Start Time (hh:mm)",
  LblDayEndTime: "Day End Time (hh:mm)",
  LblApplicableStartTime: "Applicable Start Time (hh:mm)",
  LblApplicableEndTime: "Applicable End Time (hh:mm)",
  LblComment: "Comment",
  LblProcessingFee: "Processing Fee",
  LblVatPercentage: "VAT Percentage",
  LblVatIncludedInPrice: "VAT Included In Price",
  LblPlateformUsageCost: "Platform Usage Cost",
  LblCatA: "Category A",
  LblCatB: "Category B",
  LblCatC: "Category C",
  LblCatD: "Category D",
  LblCatE: "Category E",
  LblCatF: "Category F",
  LblCatG: "Category G",
  LblCatH: "Category H",
  LblHourlyRate: "Time Cost",
  LblMileageRate: "Mileage Rate",
  LblFixedFee: "Fixed Fee",
  LblPricingModel: "Pricing Model",
  LblContractStartDateTime: "Contract Start Date/Time",
  LblContractEndDateTime: "Contract End Date/Time",
  LblContractTypeHistory: "History",
  LblContractTypPeriod: "Contract Type Period",
  LblInactiveContractTypeGroupReason:
    "Reason for deactivating Contract Type Group",
  LblPenaltyAmount: "Penalty Amount",
  LblPenaltyTimeInterval: "Penalty Time Interval (minutes)",
  LblIsPenaltyEnabled: "Penalty Enabled",
  LblTripDisplayType: "How should trips be presented in reports?",
  LblAllTripsIndividually: "All trips individually",
  LblAllTripsGrouped: "All trips grouped in one single trip",

  // DateTime Picker
  LblJanuary: "January",
  LblFebruary: "February",
  LblMarch: "March",
  LblApril: "April",
  LblMay: "May",
  LblJune: "June",
  LblJuly: "July",
  LblAugust: "August",
  LblSeptember: "September",
  LblOctober: "October",
  LblNovember: "November",
  LblDecember: "December",

  LblSJan: "Jan",
  LblSFeb: "Feb",
  LblSMar: "Mar",
  LblSApr: "Apr",
  LblSMay: "May",
  LblSJun: "Jun",
  LblSJul: "Jul",
  LblSAug: "Aug",
  LblSSep: "Sep",
  LblSOct: "Oct",
  LblSNov: "Nov",
  LblSDec: "Dec",

  LblSunday: "Sunday",
  LblMonday: "Monday",
  LblTuesday: "Tuesday",
  LblWednesday: "Wednesday",
  LblThursday: "Thursday",
  LblFriday: "Friday",
  LblSaturday: "Saturday",

  LblSSu: "Su",
  LblSMo: "Mo",
  LblSTu: "Tu",
  LblSWe: "We",
  LblSTh: "Th",
  LblSFr: "Fr",
  LblSSa: "Sa",

  //Forgot Password
  LblForgotPassword: "Forgot Password",
  LblChangePassword: "Change Password",
  LblOldPassword: "Old Password",
  LblNewPassword: "Password",
  LblProfileUpdatedSucessFully: "Profile updated successfully",
  LblPasswordChangedSucessFully: "You have successfully changed your password",

  //
  LblUpdateProfile: "Update Profile",
  LbLReasonVehicle: "Unavailability Reason",
  LblReasonDriver: "Reason for block driver",

  //Booking
  LblFrom: "From",
  LblApprovalAdminName: "Approved by admin",
  LblApprovedRejectedby: "Approved/Rejected by",
  LblBookingRequestList: "Booking Request List",
  LblTo: "To",
  LblBooking: "Booking",
  LblBookingRequest: "Booking Request",
  LblOverview: "Booking Overview",
  LblOverviewList: "Booking Overview List",
  LblApproveBooking: "Booking Approval",
  LblApprove: "Approve",
  LblBookingApprovedSuccessMsg:
    "Selected Booking Requests Approved Successfully",
  LblBookingRejectedSuccessMsg:
    "Selected Booking Requests Rejected Successfully",
  LblReject: "Reject",
  LblNormal: "New Booking",
  LblSpecial: "Special Booking",
  LblHistory: "Booking History",
  LblBookingStatus: "Booking Status",
  LblBookingType: "Booking Type",
  LblAdminRemarks: "Admin Remarks",
  LblBookingRemarks: "Booking Remarks",
  LblDriverRemarks: "Driver Remarks",
  LblBookingReferenceId: "Booking Id",
  SelectionRequiredMsg: "Please select at least one booking to approve/reject",
  LblSelectionRequired: "Selection Required",
  LblAbort: "Abort",
  LblRevoke: "Revoke",
  LblStatus: "Status",
  LblReference: "ReferenceID",
  LblRemarks: "Remarks",
  LblSearchForVehicle: "Search for Vehicle",
  LblVehicleOverview: "Vehicle Overview",
  LblConfirmBooking: "Confirm Booking",
  LblCurrentBookingDetail: "Current Booking Detail",
  LblCheckAvailability: "Check Availability",
  LblBookingStartDateTime: "Booking Start",
  LblBookingEndDateTime: "Booking End",
  LblSource: "Source",
  LblRecurring: "Recurring",
  LblRecurringId: "Recurring Id",
  LblRecurringBookingReference: "Recurring Booking Reference",
  LblDaily: "Daily",
  LblWeekly: "Weekly",
  LblMonthly: "Monthly",
  LblRecurrenceEndDate: "Recurrence End Date",
  LblSearch: "Search",
  LblBookNow: "Book Now",
  LblUpdateBooking: "Update Booking",
  LblEditCarNotAvailable: "Original booked car is not available",
  LblSortBy: "Sort By",
  LblAvaibility: "Avaibility",
  LblDistance: "Distance",
  LblNoMatchingVehicle: "No matching vehicles are found",
  LblAvailableSlots: "Available Slots",
  LblFeatures: "Features",
  LblDriverDetail: "Driver Details",
  LblBookingDetail: "Booking Details",
  LblVehicleDetail: "Vehicle Details",
  LblBookingSuccess:
    "You created a Booking request successfully. A copy of the request is sent to registered e-mail address. A notification is also sent for approval and you will be notified when the booking is accepted.",
  LblBookingUpdateSuccess:
    "Booking updated successfully. A notification is sent to driver's email address.",
  LblBlockNormalBooking:
    "Your account is blocked. Please contact administrator.",
  LblSingle: "Single",
  LblSeries: "Series",
  LblAll: "All",
  LblLicenceRequired1: "Please validate Licence Number, Go to",
  LblLicenceRequired2: "to update Licence Number details",
  LblAcceptOrReject: "Approve / Reject",

  //Special Booking
  LblSpecialBooking: "Special Booking",
  LblAffectedBooking: "Affected Booking",
  LblSpecialBookingType: "Special Booking Type",
  LblSelectSpecialBookingType: "Select Special Booking Type",
  LblSpecialBookingConfiramtionmsg: "Are you sure to create special booking ?",
  LblEndDate: "Recurrence End Date",

  // Notification
  LblNotification: "Notification",
  LblSubject: "Subject",
  LblDate: "Date",
  LblWelcomeNotification: "Welcome to WeGo Notification Inbox",

  //Template
  LblTemplate: "Template",
  LblTemplateList: "Template List",
  LblTemplateName: "Template Name",
  LblTemplateType: "Template Type",
  LblBody: "Body",
  LblIsEmailTemplate: "Email",
  LblIsWebTemplate: "Web",

  // Notification Event Management
  LblNotificationEventManagement: "Notification Events Management",
  LblNotificationEvent: "Notification Event",
  LblModuleName: "Module Name",
  LblSMS: "SMS",
  //User Type
  LblUserType: "User Type",

  //TimeBlock

  LblTimeBlock: "Time Block",
  LblTimeBlockName: "TimeBlock Name",
  LblTimeBlockWeekDays: "TimeBlock WeekDays",
  LblTimeBlockStartTime: "TimeBlock StartTime",
  LblTimeBlockEndTime: "TimeBlock EndTime",
  LblTimeBlockStartDate: "TimeBlock StartDate",
  LblTimeBlockEndDate: "TimeBlock EndDate",

  // Service Offer
  LblServiceOffer: "Service Offer",
  LblServiceOfferList: "Service Offer List",
  LblServiceOfferName: "Offer Name",
  LblServiceOfferType: "Offer Type",

  LblStandardTariff: "Standard Tariff",
  LblTimeUsedOrBooked: "Time Used/Booked",
  LblPenalty: "Penalty",
  LblAdditional: "Additional",
  LblAdditionalAbbr: "Add'l",
  LblUnit: "Unit",

  //WegoAdminList
  LblWegoAdmin: "WeGo Admin",
  LblWegoAdmins: "Wego Admins",

  LblReSend: "Resend",
  LblResendActivationMail: "Activation email",
  LblResendActivationMailFailure: "Failed to send activation email",
  LblResendActivationMailSuccess: "Activation email sent",

  //Subscription
  LblSubscription: "Subscription",
  LblSubscriptionName: "Subscription Name",
  LblTimeInterval: "Time Interval",
  LblAmount: "Amount",
  LblFreeKilometer: "Free Credits",
  LblFreeMinute: "Free Minutes",
  LblFreeHours: "Free Hours",
  LblNumberOfSubscription: "No.Of Subscriptions",
  LblUnsubscribe: "Unsubscribe",
  LblsubscribeEndDate: "Subscription End Date",
  LblSubscriptionStartDate: "Subscription Start Date",
  //Special Period
  LblSpecialPeriod: "Special Period",
  LblspecialPeriodName: "Special Period Name",
  LblSpecialPeriodStartTime: "Special Period Start Time",
  LblSpecialPeriodEndTime: "Special Period End Time",
  LblSpecialPeriodWeekDays: "Special Period WeekDays",
  LblNormalPeriod: "Normal Period",
  LblSpecialPeriods: "Special Periods",
  //Booking InvoiceModel
  LblBookingInvoice: "Booking Invoice",
  LblInvoiceStatus: "Invoice Status",
  LblInvoiceType: "Invoice Type",
  LblSummary: "Summary",
  LblTotalHours: "Total Hours",
  LblTotalKm: "Total distance (km.)",
  LblTotalExpense: "Total Expense",
  LblInvoiceNumber: "Invoice Number",
  LblBegin: "Begin",
  LblEnd: "End",
  LblVat: "VAT",
  LblDone: "Done",
  LblClear: "Clear",
  LblTotal: "Total",
  LblInvoiceRequestDateTime: "Invoice Request DateTime",
  LblInvoiceSendDateTime: "Invoice Send DateTime",
  LblInvoiceDateTime: "Invoice  DateTime",
  LblInvoiceDetail: "Invoice Detail",
  LblResend: "Resend",
  LblDownload: "Download",
  LblResendInvoiceConfirm: "Are you sure to resend %0?",
  LblSendInvoiceConfirm: "Are you sure you want to send the invoice?",
  LblPenaltyRate: "Penalty Rate",
  LblInvoicing: "Invoicing",
  LblInvoices: "Invoices",

  LblProfile: "Profile",
  LblSignOut: "Sign out",
  LblTemplateNote1:
    "Please do not change/remove the text written like this { variablename }. It is a dynamic attribute name which will be replaced with actual database entry when email will be sent to user.",
  LblTemplateNote2:
    "Please do not modify the table structure. You can create a new one. However, old one should not be modified.",
  LblTemplateNote3:
    'Please make sure once you copy placeholder and while paste it in html editor, you have to do "Paste as plain text".',
  LblConfirmUnsubscribe: "Are you sure you want to unsubscribe?",
  LblDriveHours: "Drive Hours",
  LblVehicleImage: "Vehicle Image",
  LblMaintenance: "Maintenance",
  LblUNAVAILABLE: "Unavailable",
  LblTestInvoiceGenerator: "Test Invoice Generator",
  LblMissingInvoiceGenerator: "Missing Invoice Generator",
  LblInvoicingDateTime: "Invoicing DateTime (UTC)",
  LblGenerateInvoice: "Generate Invoice",
  LblDeleteAllSelectedRecords: "Delete All Selected Record",
  LblCancelAllSelectedRecords: "Cancel All Selected Records",
  "LblExportAll(CSV)": "Export All(CSV)",
  LblAddContactPerson: "Add Contact Person",
  LblRemoveContactPerson: "Remove Contact Person",
  LblNote: "Note",
  LblCompletelyEndConfirm: "Completely End Trip",
  LblEndTrip: "End Trip",
  LblTestTrip: "Test Trip",
  LblTripSimulator: "Trip Simulator",
  LblPrePostTripQuestions: "Pre and Post Trip Questions",
  LblTestTripSuccess: "Test Trip created Successfully",
  LblDrivingStartDateTime: "Driving Start Date / Time",
  LblDrivingEndDateTime: "Driving End Date / Time",
  LblInvoiceMoment: "Invoice Moment",
  LblExtend: "Extend",
  LblExtendRequire: "Please Enter Booking Extension Time (minutes)",
  LblExtendInfoMsg: "You can extend booking up to %0 min",
  LblExtendValidationMsg: "This booking cannot be extended",
  LblExtendBooking: "Extend Booking",
  LblBookingExtendedSuccess: "Booking extended successfully",
  LblOverExtendValidationMsg: "Booking cannot be extended by more than %0 minutes",
  LblUnLock: "UnLock",
  LblLock: "Lock",
  LblVehicleStatus: "Vehicle Status",
  LblTripSuccess: "Trip saved Successfully",

  LblLockSuccessfully: "Vehicle Locked Successfully",
  LblLockCompletelySuccessfully: "Vehicle Locked Successfully",
  LblUnLockSuccessfully: "Vehicle UnLocked Successfully",
  LblUnlockProblem: "Problem during Unlock command",
  LbllockProblem: "Problem during lock command",
  LblLockCarCompletely: "Lock and close Booking",
  LblStartDateTime: "Start Date/Time",
  LblEndDateTime: "End Date/Time",
  LblBookingTripDetail: "Booking Trip Detail",
  LblAddNewTrip: "Add New Trip",
  LblBookingExpenseDetail: "Booking Expense Details",
  LblUnlockErrorMessage:
    "No Active Contract Type Group Available At Booking Creation Time",
  LblExpenseAmount: "Expense Amount",
  LblExpenseName: "Expense Name",
  LblExpenseSuccess: "Expense saved Successfully",
  LblReceipt: "Receipt",
  LblHelpdeskNo: "Helpdesk No",
  LblBookingExpired: "Vehicle Cannot be Unlock As Booking is Expired",
  LblTripCalculationInProgress:
    "We hope you had a nice trip! The vehicle will close in a few seconds.",

  LblVTSReqLogDetail: "VTS Request Log Detail",
  LblVTSReqDateTime: "Request Date/Time",
  LblVTSProcessTime: "Process Time",
  LblVTSResTime: "Result Time",
  LblVTSReqType: "Request Type",
  LblVTSResult: "Result",
  LblActualInvoiceGenerationDate: "Actual Invoice Generation Date",
  LblAvailableForAllSlots: "Vehicle available for all slots",
  LblUnAvailableSlots: "UnAvailable Slots",
  LblNoOfDrivers: "No.Of Drivers",
  LblSVGDriversList: "Shared Vehicle Group Drivers",
  LblVehicleInformation: "Vehicle Information",
  LblVTSVehicle: "VTS Vehicle",
  LblVTSVehicleUpdateSuccess: "Vehicle %0 successfully.",
  LblVTSVehicleList: "VTS Vehicle List",
  //Report Damage
  LblReportDamage: "Report Damage",
  LblCompleteDamageReport: "Complete damage report",
  LblDamageFile: "Damage File",
  LblDescribe: "Describe the damage...",
  LblCause: "Describe the cause...",
  LblReportDamageMsg: "Damage Reported successfully",
  LblSelectFile: "Please Select File",

  // Import Data
  LblCSVImport: "Import CSV",
  LblValidateCSV: "Validate CSV",
  LblImportValidPerson: "Import Valid Person",
  LblImportValidDriver: "Import Valid Driver",
  LblImportValidVehicle: "Import Valid Vehicle",
  LblCSVType: "CSV Type",
  LblCSVFile: "CSV File",
  LblRecordImportedSuccess: "%0 are imported successfully",
  LblInvalidReason: "Invalid Reason",
  LblSameVTSCommand: "Request is already in progress. Please wait.",
  LblImportPerson: "Import Person",

  //Subscription related Changes
  LblSubscriptionInterval: "Subscription Interval",
  LblPaymentInterval: "Payment Interval",
  LblInvoicInterval: "Invoice Interval",
  LblInterval: "Interval",
  LblInvoiceMomentDay: "Invoice Moment (Day of Week)",
  LblInvoiceMomentMonth: "Invoice Moment (Day of Month)",
  LblFreeMinuteInterval: "Free Minutes Interval",
  LblFreeKMInterval: "Free Kilometers Interval",
  LblSelectSubscriptionInterval: "Select Subscription Interval",
  LblSelectInvoiceInterval: "Select Invoice Interval",
  LblSelectPaymentInterval: "Select Payment Interval",
  LblSelectFreeKMInterval: "Select Free Kilometer Interval",
  LblSelectFreeMinInterval: "Select Minute Interval",
  LblYearlySub: "Yearly",
  LblMonthlySub: "Monthly",
  LblWeeklySub: "Weekly",
  LblFreePerWeek: "Per week",
  LblFreePerMonth: "Per month",
  LblFreePerTriMonth: "Per 3 months",
  LblFreePerBiannual: "Per 6 months",
  LblFreePerYear: "Per year",
  LblDefaultContractTypeGroup: "Default Contract Type Group",
  LblSelectDefaultContractTypeGroup: "Select Default Contract Type Group",
  LblSendInvoiceToDriver: "Send Invoice To Driver",
  LblInherit: "Inherit",

  //Invoice Moment
  LblDayOfMonth: "Day Of Month",
  LblDayOfWeek: "Day Of Week",
  LblSelectDayOfWeek: "Select Day Of Week",
  LblInstanceLogo: "Instance Logo",
  LblInvoiceDeleteValidation:
    "Cannot Delete Invoice Due To Association With Other Entity",

  //SubscriptionAvailabilityRestriction
  LblSubscriptionAvailabilityRestriction:
    "Subscription Availability Restriction",
  LblStartDay: "Start Day",
  LblEndDay: "End Day",
  LblStartTime: "Start Time (hh:mm)",
  LblEndTime: "End Time (hh:mm)",
  LblRestriction: "Restriction",
  LblTotalFreeKilometer: "Total Free Kilometer",
  LblTotalFreeMinute: "Total Free Minute",
  LblCurRemainFreeKilometer: "Remaining Free Kilometer",
  LblPrevRemainFreeKilometer: "Previous Remaining Free Kilometers",
  LblCurRemainFreeMinute: "Remaining Free Minute",
  LblPrevRemainFreeMinute: "Previous Remaining Free Minutes",
  LblResetPasswordFailure:
    "Password can not be reset because user is not yet activated.",

  //Additional Free Item
  LblAdditionalFreeItems: "Additional Free Credits",
  LblDateAwared: "Date Awarded",
  LblAdditionalFreeItemsMenu: "Additional Free Credits",

  LblPrevious: "Previous",
  LblCurrent: "Current",

  LblTripDetailReport: "Trip Detail Report",
  LblTripDetailList: "Detailed booking overview",
  LblSearchTripforDriver: "Search Driver Booking Trips",
  LblExportReport: "Export Report",
  LblValidateLiceanceNumberMessage: "Please Validate Your Licence Number",
  LblBookingIntervalRate: "Interval Rate",
  LblPerHour: "Per Hour",
  LblPerBookingIntarval: "Per Booking Interval",
  LblTimeRate: "Time Rate",
  LblToalBookingDuration: "Booking Duration",

  LblTripComments: "Trip Comment",
  LblTripCommentDescription: "Enter trip comment",
  LblTripCommentError: "Please enter trip comment",
  LblShowTripComment: "View comment",
  LblAddTripComment: "Add comment",
  LblTripCommentBy:"Trip Comment by",
  LblTripCommentOn: "Trip Comment op",  

  LblCleanRequire: "Cleaning Required",
  LblFualRequire: "Fuel Required",
  LblVehicleDamageList: "Vehicle Damage List",
  LblDamageCause: "Damage Cause",
  LblDamageReportedBy: "Reported By",
  LblDamageReportedOn: "Reported On",
  LblConfirmResolveDamage: "Are you sure you want to resolve vehicle damage?",
  LblVehicleDamgeResolveSuccess: "Vehicle damage resolved successfully",
  LblDamageDesc: "Damage Description",
  LblFutureBooking: "Future Bookings",
  LblVehFutureBookingList: "Vehicle Future Booking List",
  LblResolveDamge: "Resolve Damage",
  LblReserved: "Reserved",
  LblVehicleInfoSuccess: "Vehicle information updated successfully",
  LblInformation: "Information",
  LblVTSHistory: "VTS Event History",
  LblWegoRequestTime: "WeGo Request Time",
  LblVTSRequestTime: "VTS Request Time",
  LblRequestType: "Request Type",
  LblWegoProcessTime: "Wego Process Time",
  LblResult: "Result",
  LblWegoResultTime: "WeGo Result Time",
  LblVTSResultTime: "VTS Result Time",
  LblCommandInitiator: "Command Initiator",

  LblTroubleShootVTS: "VTS Troubleshoot",
  LblVtsServiceStatus: "VTS Service Status",
  LblVtsLicencetag: "VTS Licence Tag",
  LblVtsDoorStatus: "Door Status",
  LblVtsIssueCommand: "Issue Command",
  LblVehicleLocation: "Vehicle Location",
  LblEventHistory: "VTS Event History",
  LblView: "View",
  LblVehicleObuStatus: "Vehicle Obu Status",
  LblVehicleNotInitialized: "Vehicle Not Initialized",
  LblLastReceivedTime: "Last Received Message Time",

  LblFreePerBookingInterval: "Per Booking Interval",

  LblSelectFilter: "Select Filter",
  LblAuditEntries: "Audit Entries",
  LblFilter: "Filter",
  LblCategory: "Category",
  LblEventName: "Event Name",
  LblEventData: "Event Data",
  LblMoment: "Moment",
  LblUser: "User",
  LblNoEventDataFound: "No Event Data Found",
  LblEventViewer: "Event Viewer",

  LblSelectObuType: "Select OBU Type",

  LblObuType: "OBU Type",
  LblDeviceId: "Device Id",
  LblClaimCode: "Claim code",

  LblVtsLocation: "VTS Location",
  LblRetriveAddress: "Retrieve Address",
  LblCrearedDate: "Created Date",
  LblCreatedBy: "Created By",
  LblPerBooking: "Perbooking",
  LblOBU: "OBU",
  LblClone: "Clone",
  LblCloneVehicle: "Clone %0",
  LblFualNotRequire: "Fuel Not Required",
  LblCleanNotRequire: "Cleaning Not Required",
  LblSubscriptionInfo: "Subscription Info",
  LblVehiclDamaged: "Vehicle Damaged",
  LblVehicleNotDamaged: "Vehicle Not Damaged",
  LblDamage: "Damaged",
  LblFreeBooking: "Adjust Booking Cost",
  LblBookingCustomFee: "Booking Custom Cost",
  LblFreeBookingSuccess: "Booking Cost Saved Successfully",
  LblEnterLocation: "Enter Location",
  LblHomeLocation: "Home Location",
  LblLocationMode: "Location Mode",
  LblMeter: "Meter",
  LblLocation: "Location",
  LblPickupLocation: "Pickup Location",
  LblLocationUnavailable: "Location Unavailable",
  LblAvailabilityCalander: "Availability Calendar",
  LblAvailableOn: "Available On",
  LblGeofenceEnabled: "Geofence Enabled",
  LblLocationNotFound: "Cannot determine address",
  LblAddressNotAvailable: "Cannot determine address at this location",
  LblReports: "Reports",
  LblDrivers: "Drivers",
  LblTemplates: "Templates",
  LblVehicleOccupancyReport: "Vehicle Occupancy Report",
  LblPlaceHolder: "Place Holder",
  LblSampleTemplate: "Sample Template",
  LblLatexFileDownloadValidation: "Invalid Latex content",
  LblLocationDataExchangeNotAssign:
    "This vehicle cannot be booked when no VTS vehicle is assigned to it. Would you like to continue ?",
  LblReservedTime: "Reserved Time",
  LblUsageTime: "Usage Time",
  LblUsageTimeAtOffice: "Usage Time in Office Hours",
  LblUsageTimeoutOffice: "Usage Time out of Office Hours",
  LblRevenue: "Revenue",
  LblRevenuePerVehicleReport: "Revenue Per Vehicle Report",
  LblSearchRevenuePerVehicle: "Search Revenue Per Vehicle",
  LblRevenuePerVehicleList: "Revenue Per Vehicle List",

  //Dashboard
  LblInuse: "In Use",
  LblPriority: "Priority",
  LblDefaultStatus: "Default Status",

  //OdometerLogTrail
  LblOdometerLogTrail: "Odometer Log Trail",
  LblUserProvidedOdometerValueInKmr: "Odometer Value (km)",
  LblDescriptionOfDeviation: "Description of deviation",
  LblFromOdometer: "From Odometer",
  LblToOdometer: "To Odometer",
  LblAddDescriptionOfDeviation: "Add Description of Deviation",
  LblDeviation: "Deviation (km)",
  LblLastOdometerValue: "Previous odometer value (km)",
  LblLastOdometerDT: "Previous odometer date",

  LblOdometerRegistered: "Odometer Registered",
  LblOdometerValue: "Odometer Value",
  LblMaintenancePlanningList: "Maintenance Planning List",
  LblSearchMaintenancePlanningValue: "Search Maintenance Planning",
  LblMaintenancePlanningreport: "Maintenance Planning Report",

  LblodometerConfiguration: "Odometer Configuration",
  LbLOdometerEnabled: "Odometer Enabled",
  LblEnableOnApp: "Enable on App",
  LblWarningPer: "Warning (%)",
  LblShowDeviation: "Show deviation which requires explanation",

  LblTitle: "Title",
  LblFooterText: "Footer Text",
  LblvalidEmailDomain: "Only allow email addresses from the following domain",
  LblURLSettings: "URL settings",
  LblSuccessUrl: "Success URL",
  LblEmailSettings: "Email settings",
  LblSendActivationEmail: "Enable automatic activation mails",
  LblSendConfirmationEmail: "Enable signup confirmation mails",
  LblRequireAdminApprovel: "Require admin approval of new signups",
  LblDriverInformationToBeInclude:
    "Driver information to be included in form (all required fields)",
  LblSignUpForm: "Signup Form",
  LblSignupForms: "Signup Forms",
  LblSignupFormsOverview: "Signup Forms Overview",
  LblWhoCanApprove: "Who can approve new signups?",
  LblSignupFormLogo: "Signup form logo",
  LblChooseSubscription:
    "Choose the subscription(s) available to the signup form",
  LblSignupParameter: "Signup URL",
  LblSignupParameterText: "Signup URL text",
  DomainNameString: "Comma separated domain name(like gmail.com,yahoo.com)",
  SignupParameterString: "Only letters ,number and - are allowed",

  LblAvailability: "Availability",
  LblSettings: "Settings",
  LblCurrentStatus: "Current Status",
  LblFlags: "Flags",
  LblNA: "NA",

  //Sign up form
  LblConfirmEmail: "Confirm Email",
  LblSignup: "Signup",

  LblSignupsOverView: "Signups Overview",
  LblSignupApproval: "Signup Approval",
  LblAccept: "Accept",
  LblSignupFormDescription: "Signup form description",

  LblCurrentOdometerValue: "Current Odometer value",
  LblCurrentOdometerDateTime: "Current Odometer date/time",

  LblCreateDirectDebitFile: "Create Direct Debit file",
  LblCheckEmptyIbanNumber: "Check IBAN numbers",
  LblCreatedDate: "Date created",
  LblIncludeInDirectDebit: "Include in Direct Debit file",
  LblDirectDebitFileDate: "Direct Debit file date",
  LblDirectDebitConfiguration: "Direct Debit configuration",
  LbLDirectDebitEnabled: "Enable Direct Debit File generation",
  LblDirectDebitEnableper: "Direct Debit File enabled per",
  LbLCreditorDetails: "Creditor details",
  LblAddress: "Address",
  LblIBANNumber: "IBAN",
  LblCountryCode: "Country code",
  LbLBillingInformation: "Billing information",
  LblFormat: "Format",
  LblInvoicingDetails: "Invoicing Details",
  LbLSubjectToDirectDebit: "Subject to direct debit?",

  //Person Upload Batch
  LblBatchUploadPersonSetting: "Batch Import Person Setting",
  LblShowBatchUploadInfo: "Allow batch import person",
  LblAllowBatchUpload: "Allow import for",
  LblAllowActivationMail: "Use activation emails",
  LblGenerateRandomPassword: "System generates passwords",
  LblUserUploadPassword: "Import passwords",
  LblFieldToUploadedOrValidated: "Fields in importfile",
  LblBatchUploadPerson: "Batch Upload Person",
  LblBatchUpload: "Batch Upload Person",
  LblImportDriverRole: "Assign driver role automatically?",
  LblAssignToSVG: "Assign to Shared Vehicle Group(s)",
  LblSVG: "Shared Vehicle Group",
  LblDownloadTemplate: "Importfile example",
  LblUserAssignSVGMessage: "User Not Yet Assigned to Shared Vehicle Group!",
  LblInvalidRecordReason: "Invalid Record(s)",
  LblSelectedSVGs: "Selected SVG(s)",

  LblDashboard: "Dashboard",
  LblGroupAdmin: "Group Admin",
  LblDashboardConfiguration: "Dashboard Configuration",
  LblCurrentLocation: "Current Location",
  LblEnableCurrentLocation: "Enable Current Location",
  LblDefaultLocation: "Default Location",
  LblEnableAutoUpdate: "Enable Auto Update",
  LblPriorityNotificationSetting: "Vehicle Status Notification settings",
  LblCollectionDate: "Direct Debit Collection Date",
  LblBICCode: "BIC Code",
  LblDirectDebitFile: "Direct Debit File",
  LblLegacyInvoicing: "Invoices (before 2025-04-22)",
  
  LblMissingIBANNumber: "Missing IBAN",

  LblCurrentDriver: "Current Driver",
  LblNextDriver: "Next Driver",
  LblSecond: "Second(s)",

  LblCleaning: "Cleaning",
  LblRefueling: "Refueling/charging",
  LblAPKMaintenance: "Periodic Maintenance",
  LblOutsideGeofence: "Outside geofence",
  LblNotBooked: "Not Booked",
  LblNotBookedSince: "Not Booked Since",
  LblLowBattery: "Low Battery",
  LblBatteryVolt: "V.",
  LblLowCharge: "Low Charge",
  LblChargingPercentage: "%",
  LblOnSamePosition: "On Same Position",
  LblLastPosition: "Last Position",
  LblNotReturn: "Not Return",
  LblCommunicationProblem: "Communication Problem",
  LblDirectDebitDownloadSuccess: "Direct Debit file downloaded",
  LblWarnings: "Warnings",
  LblDirectDebitFileId: "Direct Debit file Id",
  LblTotalAmount: "Total Amount",
  LblReCreate: "Download again",
  LblPleaseEnterCollectionDate: "Please enter Collection Date",
  LblOpenViaLowLevel: "Opened via Low level",
  LblInstanceNotificationNote1: "Setting works as set per Company",
  LblNoInvoiceSelected: "No invoice(s) selected for direct debit file",
  LblIBANNumberRequired: "Please enter IBAN and BIC",
  LblNoEmptyIBANFound: "No empty IBAN found",
  LblInvalidTagUsed: "Invalid Tag used",
  LblNotInvalidTagUsed: "No invalid Tag used",

  LblShowVehicleChargeLevel:
    "Show vehicle charge level in web and mobile applications?",
  LblChargeLevel: "Charge Level",
  LblCharging: "Charging",
  LblNoDataFound: "No Data Available",
  LblOfficeStartTime: "Office Hours Start Time (hh:mm)",
  LblOfficeEndTime: "Office Hours End Time (hh:mm)",
  //Reports
  LblTripDataReport: "Trip Data Report",
  LblByDriver: "By Driver",
  LblByVehicle: "By Vehicle",
  LblModuleRights: "Module Rights",
  LblByOrganization: "By Organization",
  //Organization
  LblOrganization: "Organization",
  LblOrganizationName: "Organization Name",
  LblExistingDriverAddSuccessMsg:
    "Driver Added and also associated with organization successfully.",
  LblAddDriverSuccessMsg:
    "Driver Added and also activation link to that driver has been sent successfully.",
  LblOrganizationAddress: "Organization Address",
  LblCreateOrganization: "Create Organization",
  LblAddDriverToOrganization: "Add Driver To Organization",
  LblAddDriver: "Add Driver",
  LblOrganizationDriversList: "Organization Driver",
  // Branding
  LblBranding: "Branding",
  LblLogo: "Logo's",
  LblEmailNotificationInvoiceTemplate: "Email notification & invoice templates",
  LblExpandedWebMenu: "Expanded web application menu",
  LblCollapsedWebMenu: "Collapsed web application menu",
  LblMobileApp: "Mobile app",
  LblSplashScreen: "Splash screen",
  LblWebApplication: "Web application",
  LblMobileApplication: "Mobile application",
  LblBrandingSavedSuccess: "Branding saved successfully",
  LblBrandingTemplateConfiguration: "Branding & Template Configuration",
  LblAppWebUI: "App & Web UI",
  LblNonBookingCommunication: "Non-Booking Related Communication",
  LblBookingCommunication: "Booking Related Communication",
  LblInstanceBranding: "Always use Instance branding",
  LblCompanyBranding: "Use Company branding when possible",
  BO_TOP_MENU_ACTIVE_ITEM_BACKGROUND: "Top bar, menu and active items",
  BO_TOP_MENU_ACTIVE_ITEM_TEXT: "Menu text",
  BO_HIGHLIGHTED_BUTTON_BACKGROUND: "Highlighted button",
  BO_HIGHLIGHTED_BUTTON_TEXT: "Highlighted button text",
  BO_HIGHLIGHTED_BUTTON_BACKGROUND_HOVER: "Highlighted button (hover)",
  BO_HIGHLIGHTED_BUTTON_TEXT_HOVER: "Highlighted button text (hover)",
  BO_PRIMARY_BUTTON_BACKGROUND: "Primary button",
  BO_PRIMARY_BUTTON_TEXT: "Primary button text",
  BO_PRIMARY_BUTTON_BACKGROUND_HOVER: "Primary button (hover)",
  BO_PRIMARY_BUTTON_TEXT_HOVER: "Primary button text(hover)",
  BO_SECONDARY_BUTTON_BACKGROUND: "Secondary button",
  BO_SECONDARY_BUTTON_TEXT: "Secondary button text",
  BO_SECONDARY_BUTTON_BACKGROUND_HOVER: "Secondary button (hover)",
  BO_SECONDARY_BUTTON_TEXT_HOVER: "Secondary button text (hover)",
  BO_HYPERLINK_TEXT: "Hyperlink text",
  BO_HIGHLIGHT_BACKGROUND: "Highlight color",
  BO_HIGHLIGHT_TEXT: "Highlight text",
  BO_CALENDAR_EVENT_BACKGROUND: "Calendar events",
  BO_CALENDAR_EVENT_TEXT: "Calendar events text",
  MO_TOP_MENU_ACTIVE_ITEM_BACKGROUND: "Top bar and menu",
  MO_LOGO_AREA_BACKGROUND: "Logo area background",
  MO_PAGE_BACKGROUND: "Background",
  MO_MENU_TEXT: "Menu text",
  MO_TITLE_TEXT: "Title text",
  MO_HYPERLINK_TEXT: "Hyperlink text",
  MO_ENABLED_BUTTON_BACKGROUND: "Enabled button",
  MO_ENABLED_BUTTON_TEXT: "Enabled button text",
  MO_ENABLED_BUTTON_BACKGROUND_ACTIVE: "Enabled button (active)",
  MO_ENABLED_BUTTON_TEXT_ACTIVE: "Enabled button text (active)",
  MO_DISABLED_BUTTON_BACKGROUND: "Disabled button",
  MO_DISABLED_BUTTON_TEXT: "Disabled button text",
  MO_DISABLED_BUTTON_BACKGROUND_ACTIVE: "Disabled button (active)",
  MO_DISABLED_BUTTON_TEXT_ACTIVE: "Disabled button text (active)",
  MO_HIGHLIGHT_BACKGROUND: "Highlight color",
  MO_HIGHLIGHT_TEXT: "Highlight text",
  MO_CALENDAR_EVENT_BACKGROUND: "Calendar events",
  MO_CALENDAR_EVENT_TEXT: "Calendar events text",
  LblBookingDelayConfig: "Booking delay configuration",
  LblBookingDelayConfigEnabled: "Send email to admin",
  LblEnableSnauilTrail: "Enable Snail Trail",
  LblAppSupportTo: "App Support To",
  LblNotificationInterval: "Notification Interval",
  LblNotifyAfterMinutes: 'Notify After "X" Minutes',
  LblMinutesAfterBookingEndTime:
    "How many minutes after scheduled booking end time?",
  LblResendNotoficationEvery: "Resend notification every minute(s)",
  LblMinutes: "Minutes",
  lblNotificationRecipients: "Notification Recipients",
  LbLEnableBookingStillRunning: "Enable Booking Still Running Notification",
  LblBookingrunningNotification:
    "Booking still running notification configuration",
  LblPreferableImageSize: "Preferable Image Size",
  LblWebBrandingExapandImageSize: "1150px X 260px",
  LblMobileBrandingImageSize: "550px X 250px",
  LblWebBrandingCollapseImageSize: "325px X 250px",

  //MobileApp Configuration
  LblMobileAppConfiguration: "Mobile App Configuration",
  LblEnableNewBooking: "Enable New Booking",
  LblEnableBookingCalender: "Enable Booking Calender",
  LblEnableSubscription: "Enable Subscription",
  LblEnableUpdateProfile: "Enable Update Profile",
  LblEnableNotification: "Enable Notification",
  LblEnableChangeBooking: "Enable Change Booking",
  LblEnableAddExpenseMenu: "Enable Add Expense Menu",

  //Raise and clear settings for low battery flag
  LblDefaultVehicleSetting: "Default Vehicle Setting",
  LblLowBatteryFlagRaised: "Low Battery Flag raised at (voltage)",
  LblLowBatteryFlagClear: "Low Battery Flag cleared at (voltage)",
  LblByBooking: "By Booking",
  LblSnailTrailReport: "Snail Trail Report",
  LblKickbackReport: "Kickback Report",
  LblGroupBy: "Group By",
  LblTripDetail: "Trip Detail",
  LblTripNumber: "Trip No",
  LblStart: "Start",
  LblAverageSpeed: "Avg. Speed",
  LblSegmentDetail: "Segment Detail",
  LblSegmentNumber: "Segment No",
  LblSpeed: "Speed",
  LblOdometer: "Odometer",
  LblNext: "Next",
  LblSegmentDetailNotAvailable: "Segment detail not available",
  LblUnitPerKm: "per km.",
  LblUnitPerBooking: "p/bk",

  LblBookingCostSummary: "Booking Cost Summary",
  LblTimeCost: "Booking Cost",
  LblTotalTime: "Total Time",
  LblTime: "Time",
  LblCostRateUnits: "Cost (Amount * Rate)",
  LblFreeTime: "Free Time",
  LblRate: "Rate",
  LblExVat: "Ex. VAT",
  LblInclVat: "In. VAT",
  LblKmDriven: "Kms driven",
  LblFreeKms: "Free credits",
  LblTimePercent: "Time percent",
  LblTotalExVat: "Total ex. VAT",
  LblTotalVat: "Total VAT",
  LblTotalInclVat: "Total in. VAT",
  LblKilometerCost: "Kilometer Cost",
  LblFixedCost: "Fixed Cost",
  LblTotals: "Totals",
  LblTypeDamage: "Damage",
  LblTypeMaintenance: "Periodic Maintenance Due",
  LblTypeOnSamePosition: "Vehicle at same location for more than %0 %1",
  LblTypeNotBooked: "Vehicle not booked in more than %0 %1",
  LblTypeNotReturn: "Booking time expired and vehicle not at home location",
  LblBatteryVoltage: "Battery voltage",

  LblCannotUnsubscribe:
    "Cannot unsubscribe now as this user has a running booking",
  LblPer: "Per",

  LblDateRegistered: "Registered date",
  LblRegisteredBy: "Registered by",
  LblKMPerHour: "Km/h",
  LblMeters: "Meters",
  LblSubscriptionEndOnBookingEnd:
    "Booking is still running for this subscription. Driver will be unsubscribed after end of the booking.",
  LblMarkedForDeletion: "Marked for Deletion",
  LblApplyDateFilter: "Apply Date",

  LblNoRestriction: "NO_RESTRICTION",
  LblCustomAppTestApp: "CUSTOM_APP_AND_TEST_APP",
  LblCustomAppOnly: "CUSTOM_APP_ONLY",

  //Customer
  LblCustomer: "Customer",
  LblCustomerName: "Customer Name",

  //Role Page
  LblRoleManagement: "Role",
  LblRoleName: "Role Name",
  LblEntityName: "Entity Name",
  LblRoleType: "Role Type",
  LblRoleAvailability: "Customer Role Availability",
  LblInternalRoleName: "Internal Role Name",
  LblPresentationName: "Presentation Name",
  LblDefaultRole: "Default Role",
  LblCustomRole: "Custom Role",
  LblAddRole: "Add Role",
  LblEntity: "Entity",
  LblCopy: "Copy",
  LblAccessibilityMatrix: "Accessibility Matrix",
  LblDefaultRoleModifyWarning:
    "Modifying default permissions will affect all users that have the default role",
  LblCopyAccessibilityMatrix: "Copy Accessibility Matrix",
  LblAccess: "Access",
  LblCustomerAdmin: "Customer Admin",
  LblAdmin: "Admin",
  LblDoYouWantToRemove: "Do you want to remove %0 as %1?",
  LblDoYouWantToAdd: "Do you want to make %0 as %1?",
  LblRoleAddedSuccess: "%0 added to %1 successfully.",
  LblRoleDeletedSuccess: "%0 removed from %1 successfully.",
  LblInstanceAdmin: "Instance Admin",
  LblInvitationMailSuccess:
    "Invitation mail has been sent to the given email address.",
  LblInvite: "Send Invite",
  LblCreateNew: "Create New",
  LblCommonErrorMessage:
    "The server encountered an error during processing the request. Please contact administrator.",
  LblError: "Error",
  LblThankYouForAcceptingInvitation: "Thank you for accepting the invitation",
  LblPleaseClick: "Please click",
  LblHere: "here",
  LblToLogin: "to Login",
  LblThankYouForConfirmation: "Thank you for your confirmation.",
  LblGoToHome: "goto Home.",
  LblInvitationSuccess: "Invitation Success",
  LblInvitationReject: "Invitation Reject",

  //
  LblAssignExisting: "Assign Existing",
  LblPersonProfileSuccessMessage: "Your profile has been successfully activated",
  LblPlease: "Please",
  LblLogin: "Login",

  //Organization
  LblVatNumber: "VAT Number",

  //Branding & Template
  LblBrandingandTemplates: "Branding & Templates",
  LblTermsAndCondition: "Terms & Conditions",
  LblTermsAndConditionList: "T&C and Privacy Statement List",
  LblName: "Name",
  LblVersion: "Version",
  LblAcceptance1: "Before account activation",
  LblAcceptanceMoment: "Acceptance Moment",
  LblContents: "Contents",
  LblIsAccept: "I accept",
  LblReadAndAgree: "I have read and agree with",
  LblClose: "Close",
  LblTermsConditionPrivacy: "T&C and Privacy Statement",
  LblPrivacyStatements: "Privacy Statements",

  //Pre Post Trip Setting
  LblPrePostTripSetting: "Pre & Post Trip Question Setting",
  LblPrePostTripQuestion: "Pre and Post Trip Question",
  LblPrePostTripQuestionList: "Pre and Post Trip Question List",
  LblPreTripQuestion: "Pre-trip questions",
  LblCustom: "Custom",
  LblPostTripQuestion: "Post-trip questions",
  LblRequired: "Required",
  LblBeforeOpeningTheVehicle: "Before opening the vehicle",
  LblAfterOpeningTheVehicle: "After opening the vehicle",
  LblOrder: "Order",
  LblQuestion: "Question",
  LblOn: "On",
  LblOptional: "Optional",
  LblOff: "Off",
  LblAnswerType: "Answer Type",
  LblText: "Text",
  LblYesNo: "Yes/No",
  LblAnswer: "Answer",
  LblTimeStamp: "Timestamp",
  LblFazTripQuestion: "FaZ Questions",
  LblFazTripQuestionAfterClosingTheVehicle: "FaZ questions after closing the vehicle",

  //Accessibility Matrix
  LG_WEB_DASHBOARD: "Web Dashboard",
  PR_BOOKING_REQUEST: "Booking Request",
  LblApproveBookingRequest: "Approve",
  LblRejectBookingRequest: "Reject",
  PR_DASHBOARD: "Dashboard",
  PR_REMOVE_DRIVER_LICENSE: "Remove Drivers License",
  PR_VEHICLE_FUTURE_BOOKINGS: "Vehicle Future Bookings",
  PR_INSTANCE: "Instance",
  PR_BRANDING: "Branding",
  PR_PERSON_OVERVIEW: "Person Overview",
  PR_WEGO_ADMINS: "Wego Admins",
  PR_COMPANY_OVERVIEW: "Company Overview",
  PR_CONTACT_PERSON: "Contact Person",
  PR_COMPANY_ADMIN: "Company Admin",
  PR_COMPANY_VEHICLE_OVERVIEW: "Company Vehicle Overview",
  PR_COMPANY_SVG_OVERVIEW: "Company SVG Overview",
  PR_ORGANIZATION_OVERVIEW: "Organization Overview",
  PR_ORGANIZATION_CONTACT_PERSON: "Organization Contact Person",
  PR_ORGANIZATION_ADMIN_OVERVIEW: "Organization Admin Overview",
  PR_ORGANIZATION_DRIVER_OVERVIEW: "Organization Driver Overview",
  PR_SHARED_VEHICLE_GROUP_OVERVIEW: "Shared Vehicle Group Overview",
  PR_SHARED_VEHICLE_GROUP_ADMIN_OVERVIEW: "Shared Vehicle Group Admin Overview",
  PR_SHARED_VEHICLE_GROUP_VEHICLE_OVERVIEW:
    "Shared Vehicle Group Vehicle Overview",
  PR_SHARED_VEHICLE_GROUP_DRIVER_OVERVIEW:
    "Shared Vehicle Group Driver Overview",
  PR_SHARED_VEHICLE_GROUP_CONTRACT_TYPE_GROUP_OVERVIEW:
    "Shared Vehicle Group Contract Type Group Overview",
  PR_SHARED_VEHICLE_GROUP_CONTRACT_TYPE_OVERVIEW:
    "Shared Vehicle Group Contract Type Overview",
  PR_SHARED_VEHICLE_GROUP_SUBSCRIPTION_OVERVIEW:
    "Shared Vehicle Group Subscription Overview",
  PR_SHARED_VEHICLE_GROUP_SUBSCRIPTION_AVAILIBILTY_RESTRICTION_OVERVIEW:
    "Shared Vehicle Group Subscription Availibilty Restriction Overview",
  PR_SPECIAL_PERIODS: "Special Periods",
  PR_VEHICLES_OVERVIEW: "Vehicles Overview",
  PR_VEHICLE_SVG_OVERVIEW: "Vehicle SVG Overview",
  PR_VTS_VEHICLE_LIST: "VTS Vehicle List",
  PR_VTS_TROUBLESHOOT: "VTS Troubleshoot",
  PR_VEHICLE_ATTRIBUTE_CATEGORIES: "Vehicle Attribute Categories",
  PR_VEHICLE_ATTRIBUTE: "Vehicle Attribute",
  PR_ODOMETER_LOG_TRAIL: "Odometer Log Trail",
  PR_ODOMETER_LOG_TRAIL_REGISTERED_BY: "Odometer Log Trail Registered by",
  PR_DRIVER_OVERVIEW: "Driver Overview",
  PR_DRIVER_SHARED_VEHICLE_GROUP_OVERVIEW:
    "Driver Shared Vehicle Group Overview",
  PR_DRIVER_SHARED_VEHICLE_GROUP_SUBSCRIPTION_OVERVIEW:
    "Driver Shared Vehicle Group's Subscription Overview",
  PR_BOOKINGS_OVERVIEW: "Bookings Overview",
  PR_PRE_POST_TRIP_QUESTIONS: "Pre-post Trip Question Overview",
  PR_NORMAL_BOOKING: "New Booking",
  PR_SPECIAL_BOOKING: "Special Booking",
  PR_TRIP_SIMULATOR: "Trip Simulator",
  PR_INVOICE: "Invoice",
  PR_DIRECT_DEBIT_FILE: "Direct Debit File",
  PR_ADDITIONAL_FREE_ITEMS: "Additional Free Items",
  PR_TEST_INVOICE_GENERATOR: "Test Invoice Generator",
  PR_VEHICLE_OCCUPANCY_REPORT: "Vehicle Occupancy Report",
  PR_REVENUE_PER_VEHICLE_REPORT: "Revenue Per Vehicle Report",
  PR_TRIP_DATA_REPORT: "Trip Data Report",
  PR_MAINTENANCE_PLANNING_REPORT: "Maintenance Planning Report",
  PR_SANIL_TRAIL_REPORT: "Snail Trail Report",
  PR_KICKBACK_REPORT: "Kickback Report",
  PR_INVOICE_PAYMENT_HISTORY: "Invoice Payment History",
  PR_TEMPLATES: "Templates",
  PR_SIGNUP_FORMS_OVERVIEW: "Signup Forms Overview",
  PR_SIGNUPS_OVERVIEW: "Signups Overview",
  PR_SIGNUP_OVERVIEW_TO_SIGNUP_FORM: "Signup Overview to Signup Form",
  PR_SIGNUP_OVERVIEW_TO_SHARED_VEHICLE_GROUP:
    "Signup Overview to Shared Vehicle Group",
  PR_TERMS_AND_CONDITION: "Terms & Condition",
  PR_EVENT_VIEWER: "Event Viewer",
  PR_PRE_POST_TRIP_SETTING: "Pre-Post Trip Question Setting",
  PR_PREPOST_TRIP_QUESTIONS_UPDATE: "Pre Post Trip Questions",
  PR_USER_PROFILE: "User Profile",
  LG_CUSTOMER: "Customer",
  LG_INSTANCE: "Instance",
  LG_BRANDING: "Branding",
  LG_PERSON: "Person",
  LG_COMPANY: "Company",
  LG_ORGANIZATION: "Organization",
  LG_SHARED_VEHICLE_GROUP: "Shared Vehicle Group",
  LG_VEHICLE: "Vehicle",
  LG_DRIVER: "Driver",
  LG_BOOKING: "Booking",
  LG_INVOICE: "Invoice",
  LG_REPORT: "Report",
  LG_TEMPLATE: "Template",
  LG_SIGNUP_FORM: "Signup Form",
  LG_EVENT_VIEWER: "Event Viewer",
  LG_PRE_POST_TRIP_SETTING: "Pre Post Trip Question Setting",
  LG_USER: "User",
  LG_BRANDING_AND_TEMPLATE: "Branding & Templates",
  LG_ROLE: "Role",
  LG_PREPOSTTRIPQUESTION: "Pre Post Trip Questions",
  PR_CUSTOMER_ADMIN_OVERVIEW: "Customer Admin Overview",
  PR_INSTANCE_ADMIN_OVERVIEW: "Instance Admin Overview",
  PR_ROLE_OVERVIEW: "Role",
  PR_ROLE_ASSIGN: "Role Assign",
  PR_SHARED_VEHICLE_GROUP_ACTIVE_INACTIVE:
    "Shared vehicle group active or inactive",
  PR_CUSTOMER_OVERVIEW: "Customer",
  PR_ORGANIZATION_SUBSCRIPTION_OVERVIEW: "Organization Subscription Overview",
  PR_VTS_VEHICLE_EVENT_HISTORY: "VTS Vehicle Event History",
  PR_BATCH_UPLOAD_PERSON: "Person Batch Upload",
  PR_IMPORT_PERSON: "Import Person",
  PR_PRE_POST_TRIP_QUESTION_UPDATE: "Pre Post Trip Questions",

  LG_REPORTINGTOOL: "Reporting Tool",
  PR_BOOKING_OVERVIEW: "Booking overview",
  PR_ROB_NOTIFICATIONS: "ROB overview",
  PR_MILEAGE_OVERVIEW: "Mileage overview",
  PR_USAGE_OVERVIEW: "Number of days not used",
  PR_POSITION_ON_MAP: "Position on the map",
  PR_VEHICLE_ON_LOCATION_MAP: "Vehicle on location",
  PR_TRIP_OVERVIEW: "Trip registration",
  PR_ALTERNATE_TRANSPORTATION: "Alternate transportation",
  PR_AVERAGE_OVERVIEW: "Averages overview",
  PR_PRE_POST_BOOKING_OVERVIEW: "Pre/post questions per booking overview",
  PR_HOME_LOCATIONS_OVERVIEW: "Vehicle and SVG home locations overview",


  LblPrivacyErrorMessage: "You are not authorized to view this page",
  LblPrivacyNavigate: "Please navigate to",
  LblPrivacyError: "Privacy Error",
  LblLinkExpired: "Link Expired",
  LblLinkExpiredMessage:
    "Link is expired and can't be used anymore. Please try again.",
  LblBearer: "Bearer",
  LblWhoBenifitFreeItem: "Who benefits from subscription credits?",
  LblNoDistinction: "Default (no distinction)",
  LblSendInvoiceToOrganization: "Send Invoice To Organization",

  //Vat Setting
  LblVatSettings: "VAT Settings",
  LblVatPercentages: "VAT Percentages",
  LblDefaultCost: "By Default, Show and Edit Costs",
  LblExcludingVat: "Excluding VAT",
  LblIncludingVat: "Including VAT",
  LblVatEnterDescription: "Enter Description",
  LblEnterVatPercentage: "Enter VAT %",
  LblVatPercentageError: "Please enter valid percentage",
  LblVatDescriptionError: "Please enter valid Description",
  LblVatStartDate: "Start Date",
  LblVatStartDateError: "Please select start date",
  LblStartDate: "Start Date",
  LblVatEndDate: "End Date",
  LblVatDeleteConfirmation: "Are you sure you want set VAT End Date?",
  LblVatEndDateError: "Please enter VAT end date",
  LblVatEndDateNote: "Note: Data will be excluded from the selected date",
  LblDefaultVatContractTypeGroupCost: "VAT % for Contract Type Group Costs",
  LblDefaultVatContractTypeCost: "VAT % for Contract Type Costs",
  LblDefaultVatSubscriptionCost: "VAT % for Subscription Costs",
  LblPenaltyCost: "Penalty Cost",
  LblTimeRates: "Time Rates",
  LblDistanceRates: "Distance Rates",
  LblFixedRates: "Fixed Rates",
  LblSubscriptionCost: "Subscription Costs",

  LblPenaltyVat: "Penalty VAT",
  LblTimeRateVat: "Time Rate VAT",
  LblMileageRateVat: "Mileage Rate VAT",
  LblFixedFeeVat: "Fixed Fee VAT",
  LblExpenseAmountVat: "Expense Amount VAT",
  // template
  LblEmailTemplate: "Email Template",
  LblWebTemplate: "Web Template",
  LblEmailAddressesEntryPattern:
    "Comma separated email addresses(like ex1@ex.com, ex2@ex.com)",
  LblNoRecipientWarning:
    "No recipients applicable. Default recipients will be the receiver of this template.",
  LblCostAndExpenses: "Cost And Expenses",
  LblSender: "Sender",
  LblAddressee: "Addressee",
  LblAddLine: "Add Line",
  LblSaveInvoice: "Save Invoice",
  LblVatAmount: "VAT Amount",
  LblBookingId: "Booking Id",
  LblReceiptOrSuppor: "Receipt Or Support",
  LblVATPercentage: "VAT(%)",
  LblChargeTo: "Charge To",
  LblReimburseTo: "Reimburse To",
  LblReportedBy: "Reported By",
  LblReportedAmount: "Reported Amount",
  LblApprovedAmount: "Approved Amount",
  LblCostType: "Cost Type",
  LblRecipient: "Recipient",
  LblCostDetail: "Cost Detail",
  LblCostCenterReport: "Cost Center Report",
  LblShowTotalOnly: "Show Total Only",
  LblChamberOfCommerce: "Chamber of Commerce",
  LblInvoicingSettings: "Invoicing Settings",
  LblInvoiceSender: "Invoice Sender",

  LblAddExisting: "Add Existing",
  LblReceiptOrSupport: "Receipt Or Support",
  LblManualInvoiceLine: "Manual Invoice Line",
  LblInvoiceLine: "Invoice Line",
  LblInvoice: "Invoice",
  LblInvoiceLines: "Invoice Lines",
  LblSendInvoice: "Send Invoice",
  LblInvoiceSent: "Invoice Sent",
  LblAddNewInvoiceLine: "Add a new invoice line",
  LblSelectUnprocessedExpenses: "Select an unprocessed expenses",
  LblSelectAtLeastOneExpense: "Please select at least one expense",
  PR_COST_EXPENSES: "Cost And Expenses",
  PR_COST_CENTER_REPORT: "Cost Center Report",

  LblInactiveAfterDays: "Inactive After (Days)",
  LblMarkDeleteAfterDays: "Mark Delete After (Days)",
  LblNotifyAdminBeforeDays: "Notify Admin Before (Days)",
  LblGdprSettings: "GDPR Settings",
  LblRemovalDate: "Removal Date",
  LblRemovePersonOn: "Remove Person On",
  LblInvoicePaymentHistory: "Invoice Payment History",
  LblPaymentMode: "Payment Mode",
  LblLogTime: "Log Time",
  LblWhenOpeningAppAndRepeat:
    "When opening the app for the first time and repeat every",
  LblEveryTimeOpenApp: "Every time the app is opened",
  LblWhenMakeBooking: "When making a booking",
  LblWhenStartBooking: "When starting a booking",
  LblWhenOpenBooking: "When opening a vehicle",
  LblSelectContractTypeGroup: "When choosing a specific Contract Type Group(s)",
  LblDays: "Days",
  LblNewVersion: "New Version",
  LblAction: "Action",
  LblTAndCName: "T&C Name",
  LblOldVersion: "Old Version",
  LblSureToRevoke: "Are you sure to revoke T&C?",
  LblNoPaymentLinkGenerated: "No Payment Link Generated",

  //Payment Module
  LblPaymentConfig: "Payment Configuration",
  LblPaymentConfigButton: "Payment configuration",
  LblPaymentProvider: "Payment Provider",
  LblCountry: "Country",
  LblEmailAddress: "Email Address",
  LblAllowPaymentConfiguration: "Allow Payment Configuration",
  LblAllowPayment: "Allow Payment",
  LblPaymentSetting: "Payment Provider Settings",
  LblEnvironment: "Environment",
  LblInvoicePaymentTermDays: "Invoice Payment Terms Days",
  LblLinkValidityDays: "Link Validity Days",
  LblPaymentMethods: "Payment Methods",
  LblPaymentProviderSecretKey: "PSP Secret Key",
  LblPaymentProviderUsername: "PSP User Name (key)",
  LblCreditCardPayment: "Credit Card Payment",
  LblInitialPayment: "Initial Payment",
  LblCreateBookingPayment: "Create Booking Payment",
  LblStartBookingPayment: "Start Booking Payment",
  LblPaymentLink: "Payment Link",
  LblPaymentHistory: "Payment History",
  LblReasonOrganization: "Reason for blocking organization",
  LblDueDateUpdateSuccess: "Due Date Updated Successfully",
  LblDueDateRequiredError: "Please Select Due Date.",
  LblDueDate: "Due Date",
  LblConfirmDuedatechange: "Are you sure you want to update due date ?",
  LblConfirmCloseInvoice: "Are you sure you want to close invoice ?",
  LblConfirmReOpenInvoice: "Are you sure you want to reopen invoice ?",
  LblInvoiceOpenCloseSuccess: "Invoice %0 successfully",
  LblReOpen: "Reopen",
  LblClosed: "Closed",
  LblReOpenClose: "Reopen / Close",
  PR_PAYMENT_HISTORY_LIST: "Payment History",
  LblUserBlockMessage: "User Block Message",
  PR_BLOCK_UNBLOCK_ORGANIZATION: "Block / Unblock Organization",
  LblReportedOn: "Reported On",
  LblCurrencyConfiguration: "Currency Configuration",
  LblNameSingular: "Name Singular",
  LblNamePlural: "Name Plural",
  //Special Period
  LblRegularBooking: "Regular Booking",
  LblSpecialRate: "Special Rate",
  LblFirstDay: "First Day",
  LblLastDay: "Last Day",
  LblWeekEndContaining: "Weekend Containing",
  LblSignBeforeAmount: "Currency symbol before Amount",

  //Credit card payment
  LblCrediCardPayment: "Credit Card Payment",
  LblFirstBooking: "First Booking",
  LblAllowRecurringPayment: "Authorize credit card",
  LblProceed: "Proceed",
  LblCheckAllowPayment: "Please check allow recurring payment.",

  LblPaymentFailed: "Authorize credit card",
  LblPaymentSuccess: "Authorization Success",
  LblPaymentFailure: "Authorization Failure",
  LblCompletedSuccess: "Your authorization has been processed successfully",

  LblCompletedFailure:
    "Your authorization has failed. Please go back and try again.",
  LblCreditCardNumber: "Credit Card Number",
  LblCreditCardExpirationDate: "Credit Card Expiration Date",
  LblCreditCardDetails: "Credit Card Details",
  LblMakePayment: "Authorize credit card",
  LblAdminPaymentConfirmation:
    "There is no active authorisation or a deduction from the card failed. Would you like to proceed?",
  LblPaymentDescription:
    "In order to book a vehicle, a verification payment of %0 is required. Additionally, the permission to deduct future payments from your credit card is required. Payments are processed by our payment provider Buckaroo. You're being redirected to the Buckaroo website for the actual payment.",
  LblPay: "Pay",
  LblOutOf: "Out Of",
  // NIF Number
  LblEnableNIFNumber: "Enable NIF Number",
  LblNIFNumber: "NIF Number",
  LblWeGoDefault: "WeGo Default",
  LblPersonActiveSuccess: "Person Successfully Activated",
  LblActivate: 'Activate',
  LblInActiveReason: "InActive Reason",
  LblDefaultLanguage: 'Default Language',
  LblRestoreInheritConfirmation: "The current settings will be overridden by the inherited settings. Are you sure?",
  LblQestionTextRequired: "Question text required",
  LblManualSecretKey: "Secret Key",

  // Two Factor Authentication
  LblTwoFaConfig: "Two Factor Authentication",
  LblEnableTwoFa: "Enable Two Factor Authentication",
  LblExpirationDays: "Expiration Days",
  LblTextBoxExpirationDays: "Expiration Days",
  Lbl2FactorAuthenticateExpDays: "2FA expiration period (days):",
  LblResetCookiesWegoAdmin: "Reset cookies for all WeGo admin",
  LblReset2FactorAuthWegoAdmin: "Reset all 2FA for all WeGo admin",
  LblAuthentication: "Authentication",
  LblResetCookiesForAllAdmin: "Reset Cookies for all admin",
  LblReset2FaForAllAdmin: "Reset 2FA for all admin",

  LblEnterTotp: "Please enter code",
  LblEnterOtp: "Please enter code",
  LblSubmit: "Submit",
  LblKeyResetSuccess: "2FA Key has been reset",
  LblKeyResetFailed: "2FA Key reset failed",
  LblCookieResetSuccess: "2FA cookies has been reset",
  LblCookieResetFailed: "2FA cookies reset failed",
  LblGoogleAuthenticator: "Google Authenticator App",
  LblEmailOtpSent: "A code has been sent to your registered email address",
  LblContinue: "Continue",
  LblInvalidTOTP: "Invalid code",
  LblResetCookie: "Reset Cookie",
  LblResetTwoFA: "Reset 2FA",
  LblDisableTwoFA: "Disable 2FA",
  LblTwoFaMethod: "2FA Method",
  LblEmailAuthentication: "Email Authentication",
  LblTwoFaMethodSelect:"You will need to verify your identity one more time. Please select your 2FA method",
  LblInvoicePreFix: "Invoice number prefix",
  LblEngineStillRunning:'Lock command sent while engine is running',
  LblMobileAppLink: "Mobile App Link",

  // License Check Configuration
  LblLicenseCheckConfiguration: "License Check Configuration",
  LblValidateLicenseCheckForBooking: "Check for booking",

  // Access Cards Enabled SVG
  LblAccessCardsEnabled: "Access Card Use",

  // Payment Methods
  LblIdeal: "Ideal",
  LblBCMC: "BCMC",
  LblSepa: "Sepa",
  LblPaypal: "Paypal",
  LblCreditCard: "Credit card",
  LblSofort: "Sofort",
  LblMyBank: "MyBank",
  LblGiroPay: "GiroPay",

  // Track & Trace
  LblTrackAndTrace: "Track & Trace",
  LblRfidTagId: "RFID Tag ID",
  LblEmployeeNumber: "Employee number",
  BtnAddVehicleInfo: "Show Vts Log",

  // Access Card
  LblAccessCardId: "Access Card ID",

  LblDriversLicenseAndCertificates: "Driver's license and certificates",
  LblLicense: "Driver's license",
  LblCertificates: "Certificates",

  LblTrips: "Trips",
  LblCostsSummary: "Costs Summary",
  LblStartBooking: "Start booking",
  LblStopBooking: "Stop booking",

  LblTripHistory: "Trip history",
  LblTripStartDateTime : "From",
  LblTripEndDateTime: "To",
  LblFaZTripQuestions: "FaZ questions",
  LblNoQuestionsFound: "No FaZ questions found.",
  LblNoTripsFound: "No trips found.",
  LblTripDetails: "Trip details",
  LblUnansweredQuestions: "Unanswered Questions",
  LblNoUnansweredQuestions: "No unanswered Questions",
  LblAnswerSaved: "The answer is successfully saved",
  LblAnswerSavedError: "The answer could not be saved. Please contact the Administrator",
  LblAnswerEmptyError: "Please enter a valid answer",

  LblLoginError: "An unknown error ocurred while logging in",
  LblLoginCredentialsError: "This username or password is incorrect, please verify and try again",
  LblBookingStarted: "The booking has started",
  LblCouldnotStartBooking: "The booking could not be started",
  LblBookingStopped: "The booking has been stopped",
  LblCouldnotStopBooking: "The booking cannot be stopped",
  ValidatePhoneNumberVts: "Please enter valid phone number (e.g. +31623456789)",
  LblInfo: "Info"
}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./src/app/shared/translate/lang-en.ts